export const getBons = (state,bons)=>{
    state.bons = bons;
}